import styled from "styled-components";

export const Container = styled.div`
  background: #ffffff;
  border: 1px solid ${(props) => props.theme.brand.line};
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(0, 26, 51, 0.04), 0 1px 3px rgba(0, 26, 51, 0.06);
  color: ${(props) => props.theme.brand.ink};
`;
